import { render, staticRenderFns } from "./ShippingOutputForm.vue?vue&type=template&id=54b81d4d"
import script from "./ShippingOutputForm.vue?vue&type=script&lang=js"
export * from "./ShippingOutputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports